module.exports = __webpack_public_path__ + "static/berlin-2019-e8919a2bdfe8ddbb12449fbcecc12800.jpg";